import { gql } from "apollo-boost"

export const DELETE_ACTIVITIES = gql`
  mutation deleteActivities ($activityIds: [ID!]!) {
    deleteActivities(activityIds: $activityIds)
  }
`
